/** Manda o visitante (e o Google) para a URL exclusiva, preservando /inscricao e query. */
export function replaceWithExclusiveDomain(exclusiveDomain: string): void {
  try {
    const next = new URL(exclusiveDomain);
    const path = window.location.pathname;
    if (/\/inscricao\/?$/i.test(path) && !/\/inscricao\/?$/i.test(next.pathname)) {
      next.pathname = `${next.pathname.replace(/\/$/, '')}/inscricao`;
    }
    next.search = window.location.search;
    window.location.replace(next.toString());
  } catch {
    window.location.replace(exclusiveDomain);
  }
}
